import React, { useState } from 'react';
import reframe from 'nike-re-framejs';
import i18n from '@i18n';
import moment from 'moment';
import Input from '@/common/components/nikeforms/Input';
import { Submit } from '@/common/components/nikeforms/Submit';
import * as nikeformjs from 'nike-form-js';
import Immutable from 'immutable';
import { fireGAEvent } from '@/analytics';
import ticketusClient from '@/_http/axiosTicketusClient';
import { navigate } from '@/routing';
import { TICKET_DETAIL } from '@/routing/routes';
import PopupNg from '@/ui/PopupNg';
import { onChangedErrors } from '@/common/components/nikeforms/utils';

function verifyTicket(ticket, time) {
    ticketusClient
        .get('verify-ticket/mobile', {
            params: {
                ticketNoVisual: ticket,
                time: time
            }
        })
        .then(json => {
            reframe.dispatch(['ticketus/detail/fetched', Immutable.fromJS(json)]);
            navigate(TICKET_DETAIL, { hash: json.hash });
        })
        .catch(() =>
            PopupNg.dispatcher.show({
                style: 'warn',
                title: 'error.unexpected.title',
                messages: 'kontrolaTiketu.neexistuje'
            })
        );
}

const validators = [
    [
        ['ticketNumber'],
        strValue => {
            return /^[0-9]+$/.test(strValue) ? null : i18n('error.validacia.formular.cisloTiketu');
        }
    ],
    [
        ['ticketTime'],
        strValue => {
            return moment(strValue, ['HH:mm:ss'], true).isValid() ? null : i18n('error.validacia.formular.casTiketu');
        }
    ]
];

function useForm() {
    const [form] = useState(() => {
        const initData = Immutable.Map();
        return nikeformjs.makeForm(initData, {
            validator: nikeformjs.validator(validators, errors => errors),
            onFormUpdated: (form, oldForm) => {
                onChangedErrors(form, oldForm, (path, error) => {
                    fireGAEvent('Kontrola tiketu', path, error);
                });
            }
        });
    });
    const submitForm = nikeformjs.handleValidForm(form, formValues => {
        fireGAEvent('Kontrola tiketu', 'Odoslat kontrolu tiketu');
        verifyTicket(formValues.get('ticketNumber'), formValues.get('ticketTime'));
    });
    return [form, submitForm];
}

function TicketCheck() {
    const [form, submitForm] = useForm();
    return (
        <div className="page-wrap layout-rw">
            <form className="nike-form" onSubmit={submitForm}>
                <p className="nike-input" dangerouslySetInnerHTML={{ __html: i18n('kontrolaTiketu.desc') }} />
                <Input form={form} path={['ticketNumber']} label={i18n('commons.term.cisloTiketu')} />
                <Input form={form} path={['ticketTime']} label={i18n('kontrolaTiketu.hint')} />
                <Submit form={form} showError={false} forceEnabled />
            </form>
        </div>
    );
}

export default TicketCheck;
